import gql from 'graphql-tag';

const Languages = gql`
  query AllPassengerTicketLanguages($filter: PassengerTicketLanguageFilter!) {
    allPassengerTicketLanguages(filter: $filter)
  }
`;

export { Languages };



// WEBPACK FOOTER //
// ./src/queries/Languages.js